import type { Components } from '@mui/material/styles';

export default function MUIDivider(): Components['MuiDivider'] {
  return {
    styleOverrides: {
      root: {
        borderWidth: 0.5,
      },
    },
  };
}
